import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import ProductCard from './ProductCard';
import { markdownToExcerpt } from '../utils/text';

const CategoryPage = () => {
  const { categoryId } = useParams();
  const [products, setProducts] = useState([]);
  const VAT_RATE = 0.2;

  useEffect(() => {
    axios.get('https://joli-mot.fr/api-2026.php', {
      params: {
        cleApi: '34KVHFQSP226YTk4n256QP6rGbqhA5w2ymY7W3pLwdbuc3i75',
        service: 'getProductsByCategory',
        category_id: categoryId,
      },
    })
      .then((response) => setProducts(response.data.data))
      .catch((error) => console.error('Erreur chargement catégorie :', error));
  }, [categoryId]);

  return (
    <Box sx={{ padding: 3 }}>
      <Typography variant="h1" sx={{ marginBottom: 4, color: '#c48f8b', textAlign: 'center' }}>
        Produits pour {categoryId.replace('-', ' ')}
      </Typography>
      <Grid container spacing={3}>
        {/* On ne liste que les produits ayant au moins un visuel rattaché (config_carte) */}
        {products.filter((product) => product.visuels?.length > 0).map((product) => {
          const prixTTC = parseFloat(product.prix_ttc) || 0;
          const prixHT = parseFloat(product.prix_ht) || 0;
          const priceTTC = prixTTC || (prixHT * (1 + VAT_RATE)) || 0;

          return (
            <Grid item xs={12} md={4} key={product.id}>
              <ProductCard
                visuels={product.visuels?.length ? product.visuels : (product.featured_image ? [{ url: product.featured_image }] : [])}
                title={product.titre}
                price={priceTTC}
                badge={product.etiquette}
                linkTo={`/produit/${product.url}`}
                editPath={`/gestion-catalogue?editId=${product.idProd}`}
              >
                <Typography variant="body2" color="text.secondary" sx={{ flexGrow: 1 }}>
                  {markdownToExcerpt(product.description_courte || product.description, 100)}
                </Typography>
                <Button
                  variant="contained"
                  color="secondary"
                  sx={{ marginTop: 2 }}
                  component={Link}
                  to={`/produit/${product.url}`}
                >
                  Voir les détails
                </Button>
              </ProductCard>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default CategoryPage;
